import { GeoPoint } from '@common/model/location/geopoint';

export const getDeviceLocation = (): Promise<GeoPoint> =>
  new Promise((resolve, reject) => {
    if (typeof navigator === 'undefined' || typeof navigator.geolocation !== 'object') {
      reject(new Error('Geolocation api not supported'));
    }
    const api = navigator.geolocation;
    api.getCurrentPosition((position) => resolve(new GeoPoint(position.coords.latitude, position.coords.longitude)), reject);
  });
